import styled from 'styled-components';

const StyledTabs = styled.section`
    .tabsContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        
        .tabs {
            display: flex;
            gap: 25px;

            &__item {
                cursor: pointer;
                border-bottom: solid 1px transparent;
                transition: 0.3s ease all;
                text-transform: uppercase;
                font-weight: bold;

                &.active {
                    border-color: var(--brand);
                }
            }
        }
    }

    .filterContainer {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        .addressSearch {
            h4 {
                text-transform: uppercase;
            }
            
            .addressInput {
                display: flex;
                align-items: center;

                input {
                    width: 450px;    
                    padding-right: 35px;
                }

                .closeButton {
                    color: var(--brand);
                    line-height: 1;
                    margin-left: -27px;
                    cursor: pointer;

                    svg {
                        width: 11px;
                        transition: all ease-out .3s;
                    }

                    :hover svg {
                        color: #ff008cbf;
                    }
                }
            }
        }


        .date-picker-container {
            h4 {
                text-transform: uppercase;
                cursor: pointer;
                text-align: right;
            }
            
            .date-picker {
                /* .react-daterange-picker__wrapper {
                    display: none;

                } */

                .react-daterange-picker__wrapper {
                    border-color: var(--brand);
                    border-radius: 12px;
                    padding: 10px;
                }

                .react-date-picker__inputGroup__divider,
                .react-daterange-picker__range-divider {
                    color: var(--brand);
                    opacity: 0.6;
                }

                .react-daterange-picker__button:hover
                    .react-date-picker__inputGroup__divider,
                .react-daterange-picker__range-divider {
                    color: var(--brand);
                    opacity: 0.6;
                }

                .react-calendar__tile--now {
                    background-color: #ff008c30;
                }

                .react-calendar__tile--active {
                    background-color: var(--brand);
                }

                abbr {
                    text-decoration: none !important;
                    font-family: 'Poppins', sans-serif;
                }

                .react-calendar__navigation
                    .react-calendar__navigation__label__labelText {
                    font-family: 'Poppins', sans-serif;
                }

                .react-daterange-picker__inputGroup__input {
                    padding: 0 2px;
                }

                .react-calendar__month-view__days__day--weekend {
                    color: var(--brand);
                }

                .react-calendar__tile--active.react-calendar__month-view__days__day--weekend {
                    color: white;
                }

                .react-daterange-picker__button {
                    &:hover {
                        svg {
                            stroke: #ff008cba;
                        }
                    }

                    svg {
                        stroke: var(--brand);
                    }
                }
            }
        }
    }
`;

export default StyledTabs;
